import api from "../../instance/api";
import {
  errorDeliveryTrendStats,
  errorQuickStats,
  errorRiskStatus,
  startDeliveryTrendStats,
  startQuickStats,
  startRiskStatus,
  successDeliveryTrendStats,
  successQuickStats,
  successRiskStatus,
} from "../../slice/Stats";

const getQuickStats = (payload) => async (dispatch) => {
  dispatch(startQuickStats());
  try {
    const res = await api.post("summary/total-summary", payload);
    dispatch(successQuickStats(res.data));
  } catch (err) {
    dispatch(errorQuickStats(err?.response?.data?.message));
  }
};

const getDeliveryTrend = (payload) => async (dispatch) => {
  dispatch(startDeliveryTrendStats());
  try {
    const res = await api.post("summary/delivery-trend-new", payload);
    dispatch(successDeliveryTrendStats(res.data));
  } catch (err) {
    dispatch(errorDeliveryTrendStats(err?.response?.data?.message));
  }
};

const getRiskStatus = (payload) => async (dispatch) => {
  dispatch(startRiskStatus());
  try {
    const res = await api.post("risk/risk-summary", payload);
    dispatch(successRiskStatus(res.data));
  } catch (err) {
    dispatch(errorRiskStatus(err?.response?.data?.message));
  }
};

export { getQuickStats, getDeliveryTrend, getRiskStatus };
